import config from "./config";
import {
    formatDate
} from "./formatDate";
// import {
//     str
// } from "./str";


const custom = {
    // str,
    formatDate,
    config,
};

export default custom;